// @flow strict

/**
 * Capitalize passed string.
 *
 * @param {string} value - string to capitalize
 *
 * @returns {string}
 */
export function capitalize(value: string): string {
  return `${value[0].toUpperCase()}${value.substr(1).toLowerCase()}`;
}
